import cloneDeep from 'lodash/cloneDeep';

const cache = new Map();

export const setWithExpiry = (key, value, ttl) => {
  const now = new Date();
  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value,
    expiry: now.getTime() + ttl,
  };
  cache.set(key, JSON.stringify(item));
};

export const getWithExpiry = key => {
  const itemStr = cache.get(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    cache.delete(key);
    return null;
  }
  return item.value;
};
export const getCache = () => cloneDeep(cache);
